import fetchActions from 'fetchActions'

const actions = []

const subActions = {
  CURRENT: fetchActions,
}

export default [actions, subActions]
